// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
import { create } from 'zustand'
import { generateUUID } from '@/lib/utils'
import type { ToastItem } from '@/types'

interface ToastState {
  toasts: ToastItem[]
  addToast: (message: string, type?: ToastItem['type'], duration?: number) => void
  removeToast: (id: string) => void
}

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],

  addToast: (message, type = 'info', duration = 4000) => {
    const id = generateUUID()
    set((state) => ({
      toasts: [...state.toasts, { id, message, type, duration }],
    }))
    // Auto-remove
    setTimeout(() => {
      set((state) => ({
        toasts: state.toasts.filter((t) => t.id !== id),
      }))
    }, duration)
  },

  removeToast: (id) =>
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    })),
}))
